// noinspection DuplicatedCode

import { fetchWithToken } from "@platform/core";
import { reportError } from "./errors";
import React from "react";
import { WorkItem } from "../models/WorkItem";
import { WORK_ITEMS_BFF_API_BASE } from "../platform-workitems";

export function useGetWithToken<T>(
  workItem: WorkItem | undefined,
  defaultValue: T
): [
  data: T,
  isLoading: boolean,
  isErrored: boolean,
  refetch: () => void,
  errorStack: any,
  correlationId: any
] {
  const [data, setData] = React.useState<T>(defaultValue);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [isErrored, setIsErrored] = React.useState<boolean>(false);
  const uri = workItem && `${WORK_ITEMS_BFF_API_BASE}/${workItem.WorkItemIdentifier}/activity`;
  const [errorStack, setErrorStack] = React.useState<any>(null);
  const [correlationId, setCorrelationId] = React.useState<any>(null);

  React.useEffect(() => {
    if (!uri) return;
    setIsLoading(true);
    fetchWithToken(uri, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          setCorrelationId(response.headers.get("x-correlation-id"));
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then((json) => {
        setData(json);
        setIsErrored(false);
      })
      .catch((error) => {
        reportError(error);
        setErrorStack(error.stack?.toString());
        setIsErrored(true);
      })
      .finally(() => setIsLoading(false));
  }, [workItem]);

  const refetch = () => {
    if (!uri) return;
    setIsLoading(true);
    fetchWithToken(uri, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          setCorrelationId(response.headers.get("x-correlation-id"));
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then((json) => {
        setData(json);
        setIsErrored(false);
      })
      .catch((error) => {
        reportError(error);
        setErrorStack(error.stack?.toString());
        setIsErrored(true);
      })
      .finally(() => setIsLoading(false));
  };

  return [data, isLoading, isErrored, refetch, errorStack, correlationId];
}
